/* PawVibe quick add: adds one item to the cart without leaving the page */
(function () {
  if (window.__pvQuickAdd) return;
  window.__pvQuickAdd = true;

  function toast(title, img) {
    var old = document.querySelector('.pv-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'pv pv-toast';
    el.setAttribute('role', 'status');
    el.innerHTML =
      (img ? '<img src="' + img + '" alt="" width="56" height="56">' : '') +
      '<div class="pv-toast__text"><strong>Added to your cart</strong><span></span></div>' +
      '<a class="pv-btn pv-btn--primary pv-toast__btn" href="/cart">View cart</a>' +
      '<button class="pv-toast__close" type="button" aria-label="Close">&times;</button>';
    el.querySelector('span').textContent = title;
    el.querySelector('.pv-toast__close').addEventListener('click', function () { el.remove(); });
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    setTimeout(function () { el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 400); }, 6000);
  }

  function updateCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-bubble__text-count, [data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
        });
        document.querySelectorAll('.cart-bubble').forEach(function (b) {
          b.classList.toggle('visually-hidden', cart.item_count === 0);
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.pv-bundle-add')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.innerHTML;
    var items = (form.getAttribute('data-ids') || '').split(',').filter(Boolean).map(function (id) {
      return { id: Number(id), quantity: 1 };
    });
    if (!items.length) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) {
          btn.textContent = res.data && res.data.description ? 'Not available' : 'Try again';
          setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 2500);
          return;
        }
        btn.textContent = 'Added';
        var first = res.data.items && res.data.items[0];
        var img = first && first.image ? first.image + (first.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '';
        toast(items.length + ' items added. Your bundle discount is applied in the cart.', img);
        updateCount();
        setTimeout(function () { btn.disabled = false; btn.innerHTML = label; }, 2500);
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = label; });
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.pv-quick-add')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        btn.classList.remove('is-loading');
        if (!res.ok) {
          btn.textContent = 'Sold out';
          return;
        }
        btn.classList.add('is-done');
        btn.textContent = 'Added';
        toast(res.data.product_title || '', res.data.image ? res.data.image + (res.data.image.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '');
        updateCount();
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.innerHTML = label; }, 2500);
      })
      .catch(function () { form.submit(); });
  });
})();
